
import { Fragment, } from "react";
import {
    Button,
    Dialog,
    DialogHeader,
    DialogBody,
    Spinner,

} from "@material-tailwind/react";
import AIcon from "../partials/AIcon";
import { BlobProvider } from '@react-pdf/renderer';

import { useShared } from "../../hooks/useShared";
import InvoicePdf from "../../screens/invoices/InvoicePdf";
import TariffPdf from "../../screens/tariff/TariffPdf";
import PDFLetter from "../../screens/export_duty_letters/PDFLetter";

export default function PDFGenerateModal({ v }) {

    const { model, com, consts, http, toWords, Num2persian, generatePDF, setGeneratePDF, } = useShared()

    const closeDialog = (url = null) => {
        setGeneratePDF(false)
    }



    return (
        <Fragment>
            <Dialog open={generatePDF} className={`min-w-[90%] md:min-w-[20%] border-main-color   `}>
                <DialogHeader className="bg-main-color py-1 px-2 text-blue-gray-100  text-base flex justify-between">
                    Generate PDF
                    <Button className="p-0 m-0 bg-transparent" onClick={() => closeDialog(null)}>  <AIcon name="close-outline" size={20} className="p-1" /> </Button>
                </DialogHeader>
                <DialogBody divider className={`border-main-color  overflow-y-scroll  `}>
                    <BlobProvider document={v?.modelName === "Invoice" ?
                        <InvoicePdf v={{ model, com, consts, http, toWords, }} /> :
                        v?.modelName === "Tariff" ?
                        <TariffPdf v={{ model, com, consts, http, Num2persian, union:v?.union }} />:
                        <PDFLetter v={{ model, com, consts, http, Num2persian }} />
                        }
                        fileName={'Invoice.pdf'}>
                        {({ blob, url, loading, error }) => {
                            return (<> {loading ? <div className='flex items-center w-full'>  <Spinner className="h-4 w-4 mr-1" />  PDF generating ...</div> : !loading && url ?
                                <a className=" bg-main-color text-white cursor-pointer  p-2 rounded-md btn1 " href={url} target="_blank" rel="noreferrer">  را باز کنید PDF</a>
                                : null} </>)

                        }}
                    </BlobProvider>


                </DialogBody>

            </Dialog>
        </Fragment>
    );
}